import GeckoRequest from 'services/gecko-request';
import { reduxStore } from 'services/gecko-store/redux';

export const BotTagManagerService = {
  http: {
    create: (botId, name) => {
      return GeckoRequest.post(`/bots/${botId}/tags`, {
        name: name,
      });
    },
    update: (tag) => {
      return GeckoRequest.post(`/bots/${tag.bot_id}/tags/${tag.id}`, tag);
    },
    remove: (tag) => {
      return GeckoRequest.delete(`/bots/${tag.bot_id}/tags/${tag.id}`, tag);
    },
    link: (item, botTagId) => {
      return GeckoRequest.post(
        `/bots/${item.bot_id}/tags/${item.model.toLowerCase()}-bot-tag`,
        {
          [`${item.model.toLowerCase()}_id`]: item.id,
          bot_tag_id: botTagId,
        }
      );
    },
    unlink: (item, botTagId) => {
      return GeckoRequest.delete(
        `/bots/${item.bot_id}/tags/${item.model.toLowerCase()}-bot-tag`,
        {
          [`${item.model.toLowerCase()}_id`]: item.id,
          bot_tag_id: botTagId,
        }
      );
    },
  },

  dispatch: {
    getItemType: (item) =>
      item.model.toLowerCase() === 'skill' ? 'SKILL' : 'ANSWER',
    add: (item, tagId) =>
      reduxStore.dispatch({
        type: `ADDED_${BotTagManagerService.dispatch.getItemType(item)}_TAG`,
        payload: {
          id: item.id,
          data: tagId,
        },
      }),
    remove: (item, tagId) =>
      reduxStore.dispatch({
        type: `REMOVED_${BotTagManagerService.dispatch.getItemType(item)}_TAG`,
        payload: {
          id: item.id,
          data: tagId,
        },
      }),
    newTag: (tag) =>
      reduxStore.dispatch({
        type: 'NEW_BOT_TAG',
        payload: tag,
      }),
    updateTag: (tag) =>
      reduxStore.dispatch({
        type: 'UPDATE_BOT_TAG',
        payload: tag,
      }),
    deleteTag: (tag) => {
      // Remove tag
      reduxStore.dispatch({
        type: 'DELETE_BOT_TAG',
        payload: tag,
      });
      // Remove tag from skills and answers
      reduxStore.dispatch({
        type: 'DELETE_TAG_CLEANUP',
        payload: tag,
      });
    },
  },
};

export default BotTagManagerService;
